import React, { useState, useEffect, useContext } from 'react'
import noteContext from './Context/NoteContext';

const categoryIcons = [
    { id: 1, icon: "🏠", name: "Housing" },
    { id: 2, icon: "🛒", name: "Grocery" },
    { id: 3, icon: "🍽️", name: "Dining" },
    { id: 4, icon: "🚗", name: "Transport" },
    { id: 5, icon: "✈️", name: "Travel" },
    { id: 6, icon: "🎁", name: "Gifts" },
    { id: 7, icon: "🎬", name: "Entertainment" },
    { id: 8, icon: "📚", name: "Education" },
    { id: 9, icon: "💻", name: "Technology" },
    { id: 10, icon: "📱", name: "Mobile" },
    { id: 11, icon: "💡", name: "Utilities" },
    { id: 12, icon: "🩺", name: "Health" },
    { id: 13, icon: "🏋️", name: "Fitness" },
    { id: 14, icon: "👕", name: "Clothing" },
    { id: 15, icon: "🧴", name: "Personal Care" },
    { id: 16, icon: "🏦", name: "Bank" },
    { id: 17, icon: "🐾", name: "Pets" },
    { id: 18, icon: "🎓", name: "School" },
    { id: 19, icon: "🌐", name: "Online Services" },
    { id: 20, icon: "🛠️", name: "Repairs" },
    { id: 21, icon: "🍼", name: "Childcare" },
    { id: 22, icon: "🎵", name: "Music" },
    { id: 23, icon: "📦", name: "Subscriptions" },
    { id: 24, icon: "🍿", name: "Movies" },
    { id: 25, icon: "🎨", name: "Hobbies" },
    { id: 26, icon: "📞", name: "Communication" },
    { id: 27, icon: "🏖️", name: "Vacation" },
    { id: 28, icon: "🛏️", name: "Furniture" },
    { id: 29, icon: "🥂", name: "Celebrations" },
    { id: 34, icon: "🎁", name: "Gifts/Donations" },
];


export default function Categories() {

    const {
        expenseList, setExpenseList,
        categories, setCategories,
        isModal, setisModal,
        modalType, setModalType,
        edittmp, setedittmp,
        ind, setind,
        allCat, setAllCat,
        openModal, closeModal, setmodalTypeAndOpen,
        Income, setIncome,
        Expense, setExpense
    } = useContext(noteContext);

    const [cat, setCat] = useState({})

    return (
        <>
            <div className="categorybox">
                {categoryIcons.map((item, index) => {
                    return (
                        // <button className="categoryButton" key={item.id} onClick={() => {
                        //     setCat(item);
                        //     setCategories(item);
                        //     if (modalType === "category") { setModalType("addValue") } if (modalType === "editCategory") { setModalType("Edit") }
                        // }}>

                        // Find this line in your Categories component:
                        <button className="categoryButton" key={item.id} onClick={() => {
                            setCat(item);
                            setCategories(item);

                            // ADD THIS LOGIC:
                            if (modalType === "category") {
                                setModalType("addValue"); // This "reveals" the hidden form
                            }
                            if (modalType === "editCategory") {
                                setModalType("Edit");
                            }
                        }}>


                            <div>
                                <div className="categoryButton2">
                                    <div className="categoryIcon">{item.icon}</div>
                                    <div className="categoryText">{item.name}</div>
                                </div>
                            </div>
                        </button>

                    )
                }
                )
                }
            </div>
        </>
    )
}
// expenseList.length!==0?expenseList[ind].categories?.name:null
export function OnlyCategoriesList() {

    const {
        expenseList, setExpenseList,
        ind, setind, Income, setIncome,
        Expense, setExpense
    } = useContext(noteContext);

    const [onCatOnly, setOnCatOnly] = useState([])
    useEffect(() => {
        const newList = categoryIcons.map(item => ({ Category: item.name, inp: 0 }))
        // const totalCategory=expenseList.forEach(item=>{
        // onCatOnly[item.categories.name]+=Number(item.inp)
        // })
        // const xl=expenseList[2]?.categories?.name??null;
        // const totalCategory=onCatOnly.find(item=>item.Category===xl)
        // if(totalCategory){
        //     totalCategory.inp+=Number(expenseList[2].inp)
        //     onCatOnly[0]=totalCategory
        // }
        expenseList && expenseList.forEach(item => {
            const x1 = newList.find(x2 => x2.Category === item.category?.name)
            if (x1) {
                if (item.type === "Expense") {
                    { x1.inp += Number(item.amount) }
                }
                if (item.type === "Income") {
                    { }
                }
            }
        })
        setOnCatOnly(newList);
    }, [expenseList]);
    const indvidual = Expense > 0 ? Expense : 1
    return (<>
        {/* <div >{onCatOnly.map((item)=><div className="onCat" key={item.id}>{item}</div>)}</div> */}
        {onCatOnly.sort((a, b) => b.inp - a.inp).slice(0, 30).map(((item, index) => <div className="onCat" key={item.id}>
            <div className="onCat">
                <div className="onCat" style={{ height: "20px", width: "40px", backgroundColor: "var(--primary-color)", borderRadius: "1rem", color: "white" }}>{Math.round(((item.inp) / indvidual) * 100)}%</div>
                {item.Category}</div>
            <div className="onCat">${item.inp}</div>
        </div>))}
    </>
    )
}


